import React, { useEffect, useRef, useState } from "react";
import {
  Box,
  Typography,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Grid,
  styled,
  Stack,
  Divider,
  Button,
  Avatar,
} from "@mui/material";
import { useApi } from "../store/UserLoginContext";
import moment from "moment";

const NewForm = (props, currentSessionAY, ref) => {
  const [studentData, setStudentData] = useState(false);

  useEffect(() => {
    setStudentData({
      refNo: "XXX",
      date: "DD/MM/YYYY",
    });

  }, [])
  console.log(props);
  return (
    <>
      <Box
        ref={ref}
        sx={{
          width: "186mm",
          minHeight: "272mm",
          // padding: "1mm",
          bgcolor: "#fff",
          color: "#000",
          fontSize: "13px", // slightly reduced
          lineHeight: 1.6,
          fontFamily: "serif",
          border: "5px double black",
          mb: "2mm",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <style>
          {`@media print {
            @page {
              size: A4 portrait;
              margin: 10mm;
            }
          }`}
        </style>

        {/* Header */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            borderBottom: "2px solid black",
          }}
        >
          <Box width="100%" bgcolor="grey.100" p={1}>
            <Grid container alignItems="center" justifyContent="space-between">
              <Grid item>
                <img
                  src="/img/vpm_gns_logo.png"
                  width={100}
                  height={"auto"}
                  alt="School Logo"
                />
              </Grid>
              <Grid item xs textAlign="center" mr={10}>
                <Typography sx={{ fontFamily: "Alien Invader", fontSize: 26 }}>
                  V.P.M Gyan Niketan School
                </Typography>
                <Typography>
                  A sr.secondary (10+2) school, Affiliated to C.B.S.E, Delhi
                </Typography>
                <Typography variant="caption">
                  Affiliation no. 3430175, School Code - 66373, U-Dise no.
                  20020102742
                </Typography>
              </Grid>
            </Grid>
          </Box>
        </Box>

        {/* Body */}
        <Box
          sx={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            position: "relative",
          }}
        >
          <img
            src="/img/vpm_gns_logo.png"
            style={{
              position: "absolute",
              top: "30%",
              left: "5%",
              zIndex: 1,
              width: "90%",
              opacity: "0.10",
            }}
          />
          <Box
            sx={{
              marginTop: "14mm",
              paddingLeft: "10mm",
              paddingRight: "10mm",
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
            }}
          >
            <Box 
              sx={{
                display:'flex',
              }}
            >
              <Typography variant="body2" color="black">
                Ref. no.
              </Typography>
              <TextField
                sx={{}}
                variant="standard"
                InputProps={{
                  disableUnderline: true,
                  sx: {
                    fontSize: "0.875rem",
                    padding: 0,
                    ml: 0.5,
                    mt: -0.5,
                    flex: 1, // input takes remaining space
                    textTransform: "uppercase",
                  },
                }}
                inputProps={{
                  maxLength: 25,
                  style: {
                    textTransform: "uppercase",
                    textAlign: "left",
                  },
                }}
                value={studentData.refNo}
                onChange={(e) => {
                  setStudentData((prev) => {
                    return { ...prev, refNo: e.target.value };
                  });
                }}
              />
            </Box>
            <Box
              sx={{
                display: "flex",
                width: "38mm",
              }}
            >
              <Typography variant="body2" color="black">
                Date:-{" "}
              </Typography>
              <TextField
                sx={{}}
                variant="standard"
                InputProps={{
                  disableUnderline: true,
                  sx: {
                    fontSize: "0.875rem",
                    padding: 0,
                    ml: 0.5,
                    mt: -0.5,
                    flex: 1, // input takes remaining space
                    textTransform: "uppercase",
                  },
                }}
                inputProps={{
                  maxLength: 25,
                  style: {
                    textTransform: "uppercase",
                    textAlign: "left",
                  },
                }}
                value={studentData.date}
                onChange={(e) => {
                  setStudentData((prev) => {
                    return { ...prev, date: e.target.value };
                  });
                }}
              />
            </Box>
          </Box>
          <Box
            sx={{
              justifyItems: "center",
              marginTop: "40mm",
            }}
          >
            <Typography variant="h4" weight="bold" color="black" sx={{
              textAlign: "center",
              textDecoration: "underline",
              fontWeight: "bold",
            }}>
              To Whom It May Concern
            </Typography>
          </Box>
          <Box
            sx={{
              justifyContent: "center",
              paddingLeft: "10mm",
              paddingRight: "10mm",
              paddingTop: "10mm",
              paddingBottom: "4mm",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Typography sx={{ textIndent:"16mm"}}>
              Certified that <strong>{props?.name}</strong> s/d of Mrs. <strong>{props?.motherName}</strong> 
              and Mr. <strong>{props?.fatherName}</strong>, resident of <strong>{props?.address.addressline1}</strong>,
              <strong>{props?.address.city}</strong>, District - <strong>{props?.address.district}</strong>,
              State - <strong>{props?.address.state}</strong> is a regular and bonafide student of
              Class <strong>{props?.className}</strong> (Session {currentSessionAY}) of  this school.
            </Typography>
            <Typography sx={{ textIndent:"34mm"}} mt={"2mm"}>
              According to Admission Register (Adm.no. <strong>{props.admissionNo}</strong>)his/her
              Date of Birth is <strong>{moment(props?.dob).format("DD/MM/YYYY")}</strong>.
              He/She bears a good moral character.
            </Typography>
            <Typography textAlign={"center"} mt={"4mm"}>
              This is for your kind information and needful.
            </Typography>
          </Box>
          <Box
            sx={{
              paddingTop: "28mm",
              justifyItems: "right",
              paddingRight: "20mm",
            }}
            mt={"auto"}
            mb={"10mm"}
          >
            <Typography variant="h6" color="black">
              Principal
            </Typography>
          </Box>
        </Box>
        {/* Footer */}
        <Box width="auto" bgcolor="grey.100" p={1.5} justifyItems={"center"}>
          <Box>
            <Typography variant="caption2">
              Bairia,Daltonganj,Palamu,Jharkhand-822102 | Mob.-6205574800 |
              email-vpmgns66373@gmail.com | Website-www.vpmgns.com
            </Typography>
          </Box>
        </Box>

      </Box>
    </>
  );
};


const BonafideReportTemplate = React.forwardRef(({data}, ref) => {
  const { currentSessionAY } = useApi();
  return <div ref={ref}>{NewForm(data, currentSessionAY, ref)}</div>;
});

export default BonafideReportTemplate;